<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">About the Author</h1>
<p class="nonindent"><span class="small"><strong>ANNE HERRIES</strong></span> lives in Cambridgeshire, where she is fond of watching wildlife, and spoils the birds and squirrels that are frequent visitors to her garden. Anne loves to write about the beauty of nature, and sometimes puts a little into her books—although they are mostly about love and romance. She writes for her own enjoyment, and to give pleasure to her readers. She is a winner of the Romantic Novelists’ Association Romance Prize. She invites readers to contact her on her website at <a href="http://www.lindasole.co.uk" target="_blank">www.lindasole.co.uk</a>.</p>
<p class="extract"><strong>Previous novels by the same author:</strong></p>
<p class="extract">MARRYING CAPTAIN JACK<br/>THE UNKNOWN HEIR<br/>THE HOMELESS HEIRESS<br/>THE RAKE’S REBELLIOUS LADY<br/>A COUNTRY MISS IN HANOVER SQUARE<a class="hlink" href="#/OEBPS/#kap1" id="kap1a">*</a><br/>AN INNOCENT DEBUTANTE IN HANOVER SQUARE<a class="hlink" href="#/OEBPS/#kap1">*</a><br/>THE MISTRESS OF HANOVER SQUARE<a class="hlink" href="#/OEBPS/#kap1">*</a><br/>FORBIDDEN LADY<a class="hlink" href="#/OEBPS/#kap2" id="kap2a">†</a><br/>THE LORD’S FORCED BRIDE<a class="hlink" href="#/OEBPS/#kap2">†</a><br/>THE PIRATE’S WILLING CAPTIVE<a class="hlink" href="#/OEBPS/#kap2">†</a><br/>HER DARK AND DANGEROUS LORD<a class="hlink" href="#/OEBPS/#kap2">†</a><br/>BOUGHT FOR THE HAREM</p>
<p class="extract"><a class="hlink" href="#/OEBPS/#kap1a" id="kap1">*</a><em>A Season in Town</em> trilogy<br/><a class="hlink" href="#/OEBPS/#kap2a" id="kap2">†</a><em>The Melford Dynasty</em></p>
<p class="extract"><strong>And in the Regency series</strong><br/><strong><em>The Steepwood Scandal</em></strong><strong>:</strong></p>
<p class="extract">LORD RAVENSDEN’S MARRIAGE<br/>COUNTERFEIT EARL</p>
<p class="extract"><strong>And in</strong> <strong><em>The Hellfire Mysteries</em></strong><strong>:</strong></p>
<p class="extract">AN IMPROPER COMPANION<br/>A WEALTHY WIDOW<br/>A WORTHY GENTLEMAN</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ata.vue?25c9e46c